import { Injectable } from "@angular/core";
import type { UserModel } from "../models/user/user.model";
import { MenuStore } from "../stores/menu.store";
import { ProviderStore } from "../stores/provider.store";
import { RouteBreadcrumbStore } from "../stores/route-breadcrumb.store";
import { StoreStore } from "../stores/store.store";
import { UserStore } from "../stores/user.store";
import { toObservable } from "@angular/core/rxjs-interop";

@Injectable({ providedIn: "root" })
export class AppInitService {
  private initialized = false;

  constructor(
    private readonly userStore: UserStore,
    private readonly providerStore: ProviderStore,
    private readonly storeStore: StoreStore,
    private readonly routeBreadcrumbStore: RouteBreadcrumbStore,
    private readonly menuStore: MenuStore
  ) {
    toObservable(this.userStore.user).subscribe((user: UserModel) => {
      if (this.userStore.isAuthenticated() && user && !this.initialized) {
        this.providerStore.initialize();
        this.storeStore.initialize();
        this.routeBreadcrumbStore.initialize();
        this.menuStore.initialize();
        this.initialized = true;
      }
    });
  }
}
